import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'

type Props = {
  children: React.ReactNode
}

export default function PrivateRoute({ children }: Props) {
  const { signed, loading } = useAuth()

  if (loading) {
    return <div>Carregando...</div>
  }

  if (!signed) {
    return <Navigate to='/' replace />
  }

  return <>{children}</>
}
